import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePlans } from "@/hooks/usePlans";

interface PlanSelectionStepProps {
  form: UseFormReturn<any>;
}

export function PlanSelectionStep({ form }: PlanSelectionStepProps) {
  const { plans } = usePlans();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Seleção do Plano</h3>
      
      <FormField
        control={form.control}
        name="planId"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Selecione o Plano *</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className="grid grid-cols-2 gap-4"
              >
                {plans?.filter(p => p.is_active).map((plan) => (
                  <label
                    key={plan.id}
                    className={`cursor-pointer ${field.value === plan.id ? 'ring-2 ring-primary' : ''}`}
                  >
                    <Card>
                      <CardHeader>
                        <div className="flex items-center justify-between">
                          <RadioGroupItem value={plan.id} />
                          <CardTitle className="text-base">{plan.name}</CardTitle>
                        </div>
                        <CardDescription>
                          R$ {plan.price_monthly}/mês
                        </CardDescription>
                      </CardHeader>
                    </Card>
                  </label>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
